import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, countries, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the competitors table view.
 * @extends JetView
 */
export default class tableCompetitorsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const data = [
            // Sample data for competitors
            {
                Id: '01',
                Name: 'Competidor 1',
                CountryId: '173',
                Country: 'Peru',
                CountryIcon: 'pe',
            },
            {
                Id: '02',
                Name: 'Competidor 2',
                CountryId: '2',
                Country: 'Nicaragua',
                CountryIcon: 'ni',
            },
        ];
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the DataTable
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                // Column definitions for the DataTable
                                {
                                    id: 'rating',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Editar'), // Tooltip for edit action
                                    template: function (obj) {
                                        // Template for the rating column
                                        if (devConfig.getPermAction('competitorsEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'ID', // Column header for ID
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name',
                                    header: _('Nombre'), // Localized column header for Name
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Country',
                                    header: _('País'), // Localized column header for Country
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 200,
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Template for the Country column
                                        return "<i class='flags " + obj.CountryIcon + "'></i>" + obj.Country; // Display country flag and name
                                    },
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    $$('editCompetitors').show(); // Show edit popup
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Preload data setting
                            pager: 'pagerA', // ID for the pager
                            data: data, // Initial data for the DataTable
                            // API endpoint for fetching competitors
                            url: devConfig.geturlApi() + 'Competitors/GetCompetitors',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the DataTable instance
        var url = grid.data.url; // URL for data fetching
        const _ = this.app.getService('locale')._; // Localization service
        var filter = ''; // Filter string for data fetching
        this.on(this.app, 'competitors:filter', (filterData) => {
            // Event handler for filtering competitors
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filter values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        this.on(this.app, 'addCompetitor:button', (filter) => {
            // Event handler for adding competitor
            popupAdd.show(); // Show add competitor popup
        });
        var popupAdd = webix.ui({
            // Configuration for add competitor popup
            view: 'window',
            id: 'addCompetitors', // ID for the add competitor window
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Competidor') }, // Label for the toolbar
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal window
            width: 5000, // Width of the popup
            body: {
                view: 'form', // Form for adding competitor
                id: 'saveform', // ID for the form
                elements: [
                    {
                        view: 'text',
                        name: 'Name', // Field name for competitor name
                        label: "<span class='icon-user'></span>" + _('Nombre'), // Label for the field
                        labelWidth: 150,
                        width: 300,
                    },
                    {
                        view: 'richselect',
                        name: 'CountryId', // Field name for country selection
                        localId: 'regions:combo',
                        label: "<span class='icon-language'></span>" + _('País'), // Label for the field
                        labelPosition: 'top',
                        placeholder: _('Click para seleccionar '), // Placeholder text
                        options: {
                            body: {
                                template: function (obj) {
                                    // Template for country options
                                    return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                },
                                data: countries, // Data for country options
                            },
                        },
                        hidden: devConfig.getCountryReport(), // Conditional visibility based on config
                    },
                    {
                        view: 'richselect',
                        name: 'CountrySelect2', // Field name for country selection (readonly)
                        localId: 'regions:combo',
                        label: "<span class='icon-language'></span>" + _('País'), // Label for the field
                        labelPosition: 'top',
                        placeholder: _('Click para seleccionar '), // Placeholder text
                        value: profile.Settings.ReportCountry, // Default value
                        readonly: true, // Make field readonly
                        options: {
                            body: {
                                template: function (obj) {
                                    // Template for country options
                                    return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                },
                                data: countries, // Data for country options
                            },
                        },
                        hidden: !devConfig.getCountryReport(), // Conditional visibility based on config
                        css: 'country-hide', // CSS class for styling
                    },
                    {
                        cols: [
                            // Button layout
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('saveform').getValues(); // Get form values
                                    if (devConfig.getCountryReport()) {
                                        // Check country report config
                                        values.CountryId = profile.Settings.ReportCountry; // Set country ID
                                    }
                                    delete values['CountrySelect2']; // Remove unused field
                                    webix
                                        .ajax() // AJAX request to save competitor
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Competitors/AddCompetitor',
                                            '{"Name":"' + values.Name + '","CountryId":"' + values.CountryId + '"}', // Request body
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Competidor Agregado'), // Success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(url); // Reload grid data
                                                },
                                            },
                                        );
                                    $$('saveform').clear(); // Clear form fields
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                        ],
                    },
                ],
            },
        });
        var popupEdit = webix.ui({
            // Configuration for edit competitor popup
            view: 'window',
            id: 'editCompetitors', // ID for the edit competitor window
            head: _('Editar Competidor'), // Header for the window
            position: 'center', // Center position for the popup
            modal: true, // Modal window
            width: 5000, // Width of the popup
            body: {
                view: 'form', // Form for editing competitor
                id: 'editform', // ID for the form
                elements: [
                    {
                        view: 'text',
                        name: 'Id', // Field name for competitor ID
                        label: "<span class='icon-id'></span> ID", // Label for the field
                        labelWidth: 150,
                        width: 300,
                        disabled: true, // Make field disabled
                    },
                    {
                        view: 'text',
                        name: 'Name', // Field name for competitor name
                        label: "<span class='icon-user'></span>" + _('Nombre'), // Label for the field
                        labelWidth: 150,
                        width: 300,
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'richselect',
                        name: 'CountryId', // Field name for country selection
                        localId: 'regions:combo',
                        label: "<span class='icon-language'></span>" + _('País'), // Label for the field
                        labelPosition: 'top',
                        placeholder: _('Click para seleccionar '), // Placeholder text
                        options: {
                            body: {
                                template: function (obj) {
                                    // Template for country options
                                    return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                },
                                data: countries, // Data for country options
                            },
                        },
                        hidden: devConfig.getCountryReport(), // Conditional visibility based on config
                    },
                    {
                        view: 'richselect',
                        name: 'CountrySelect2', // Field name for country selection (readonly)
                        localId: 'regions:combo',
                        label: "<span class='icon-language'></span>" + _('País'), // Label for the field
                        labelPosition: 'top',
                        placeholder: _('Click para seleccionar '), // Placeholder text
                        value: profile.Settings.ReportCountry, // Default value
                        readonly: true, // Make field readonly
                        options: {
                            body: {
                                template: function (obj) {
                                    // Template for country options
                                    return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                },
                                data: countries, // Data for country options
                            },
                        },
                        hidden: !devConfig.getCountryReport(), // Conditional visibility based on config
                        css: 'country-hide', // CSS class for styling
                    },
                    {
                        cols: [
                            // Button layout
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('editform').getValues(); // Get form values
                                    if (devConfig.getCountryReport()) {
                                        // Check country report config
                                        values.CountryId = profile.Settings.ReportCountry; // Set country ID
                                    }
                                    delete values['CountrySelect2']; // Remove unused field
                                    webix
                                        .ajax() // AJAX request to update competitor
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Competitors/UpdateCompetitor',
                                            '{"Id":"' +
                                                values.Id +
                                                '","Name":"' +
                                                values.Name +
                                                '","CountryId":"' +
                                                values.CountryId +
                                                '"}', // Request body
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Competidor Editado'), // Success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(url); // Reload grid data
                                                },
                                            },
                                        );
                                    $$('editform').clear(); // Clear form fields
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                        ],
                    },
                ],
            },
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id, // Load data based on selected player ID
            );
        });
        $$('editform').bind($$('datatable')); // Bind edit form to DataTable
    }
}

// FILE DOCUMENTED
